var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-table',{attrs:{"items":_vm.items,"fields":_vm.fields,"outlined":""},scopedSlots:_vm._u([{key:"name",fn:function(ref){
var item = ref.item;
return [_c('b-btn',{attrs:{"variant":"link","to":{
        name: 'project-property-keys-edit',
        params: {
          id: item.id
        }
      }}},[_vm._v("\n      "+_vm._s(item.name)+"\n    ")])]}},{key:"actions",fn:function(ref){
      var item = ref.item;
return [_c('b-btn',{attrs:{"variant":"danger"},on:{"click":function($event){return _vm.deleteItem(item.id)}}},[_vm._v("\n      削除\n    ")])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }